import { FormGroup } from '@angular/forms';

export class ValidationserviceProvider {
    static getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
        let config = {
            'required': 'Required',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Invalid email address',
            'invalidphne': 'Phone number needs to start with + followed by country code. Otherwise WhatsApp will not work',
            'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
            'passwordnomatch': 'Passwords do not match. Please reenter the passwords',
            'minlength': `Minimum length ${validatorValue.requiredLength}`,
            'maxlength': `Maximum length ${validatorValue.requiredLength}`,
            'min': `Minimum value ${validatorValue.min}`,
            'max': `Maximum value ${validatorValue.max}`
        };

        return config[validatorName];
    }

    static emailValidator(control) {
        // RFC 2822 compliant regex
        if (control.value === "" || control.value === null) {
            return null;
        }
        else if (control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return null;
        } else {
            return { 'invalidEmailAddress': true };
        }
    }

    static phoneValidator(control) {
        // RFC 2822 compliant regex
        if (control.value.startsWith("+")) {
            return null;
        } else {
            return { 'invalidphne': true };
        }
    }

    static passwordValidator(control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
         //if (control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
        //if (control.value.match(/.*{6,100}$/)) {
        if (control.value.match(/[.*]{6,100}$/)) {
        // if (control.value.match(/^(?=.*)[a-zA-Z!@#$%^&*]{6,100}$/)) {
            return null;
        } else {
            return { 'invalidPassword': true };
        }
    }

    static passwordMatch(rpwdGrp: FormGroup) {

        if (  !rpwdGrp.controls )
        {
            return null;
        }
        let password = rpwdGrp.controls.mb_password_new.value; // to get value in input tag
        let confirmPassword = rpwdGrp.controls.mb_password_repeat.value; // to get value in input tag

        if (password === confirmPassword) {
            return null;
        } else {
            return { 'passwordnomatch': true };
        }
    }

    static creditCardValidator(control) {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
            return null;
        } else {
            return { 'invalidCreditCard': true };
        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/dbservice/validationservice.ts